import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from '@azure/msal-react'
import React from 'react'
import { IHeaderProps } from '../interfaces/Header.Interface'
import Icon from '../../svg/Icon'
import useLoggedInCookie from '../../../hooks/useLoggedInCookie'

export const HeaderOverlay = ({
  id,
  active,
  closeClick,
  searchClick,
  children,
}: IHeaderProps) => {
  const { instance } = useMsal()
  const govCMSHome = process.env.REACT_APP_GOVCMS_HOME
  const [, removeLoggedInCookie] = useLoggedInCookie()
  const registrationUrl = process.env.REACT_APP_AZURE_B2C_REGISTRATION_URL
  return (
    <>
      <div id={id} className={!active ? 'overlay' : 'overlay is-open'}>
        <div className="header">
          <button onClick={closeClick} className="close-overlay button">
            <Icon name="clear" />
            <span>Close</span>
          </button>
          <span className="logo left">
            <a href={govCMSHome}>
              <Icon name="fairwork" />
              <span className="sr-only">Go to home page</span>
            </a>
          </span>
          <AuthenticatedTemplate>
            <a href="/" className="my-account-menu button">
              MY ACCOUNT
            </a>
          </AuthenticatedTemplate>
          <AuthenticatedTemplate>
            <button
              className="my-account-menu button"
              onClick={() => {
                removeLoggedInCookie()
                instance.logoutRedirect()
              }}
            >
              Logout
            </button>
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <button
              className="my-account-menu button"
              id="authenticationButton"
              onClick={() => instance.loginRedirect()}
            >
              Login
            </button>
          </UnauthenticatedTemplate>
          <UnauthenticatedTemplate>
            <a className="my-account-menu button" href={registrationUrl}>
              Register
            </a>
          </UnauthenticatedTemplate>
          <a
            className="open-search"
            tabIndex={0}
            href={govCMSHome}
            onClick={searchClick}
          >
            <span className="sr-only">Open search box</span>
            <Icon
              name="search"
              width="10"
              height="10"
              aria-label="Open search box"
            />
          </a>
        </div>
        {children}
      </div>
    </>
  )
}
